import {defineMessages} from 'react-intl'

export default defineMessages({
    title: {
        id: 'containers.AiPage.title',
        defaultMessage: 'Free AI Voice Over Generator',
    },
    subtitle: {
        id: 'containers.AiPage.subtitle',
        defaultMessage: 'Instant text-to-speech, enabled by real human voice talents.',
    },
    description: {
        id: 'containers.AiPage.description',
        defaultMessage: 'Instantly test your voice over script for timing and tone of voice - and find out if your selected voice is right for your project. Try the new AI voice over generator free below.',
    },
    goBack: {
        id: 'containers.AiPage.goBack',
        defaultMessage: 'Explore more voices',
    },
    generateVoice: {
        id: 'containers.AiPage.generateVoice',
        defaultMessage: 'Generate',
    },
    scriptPlaceholder: {
        id: 'containers.AiPage.scriptPlaceholder',
        defaultMessage: 'Enter your script here (max 200 characters)',
    },
    processing: {
        id: 'containers.AiPage.processing',
        defaultMessage: 'Processing...',
    },
    download: {
        id: 'containers.AiPage.download',
        defaultMessage: 'Download',
    },
    select: {
        id: 'containers.AiPage.select',
        defaultMessage: 'Select',
    },
    collaboration: {
        id: 'containers.AiPage.collaboration',
        defaultMessage: 'This AI voice is made available to you, in collaboration with {sku}. The unique voice is the original source of the synthetic replica you are able to demo and try to the right.',
    },
    nativeIn: {
        id: 'containers.AiPage.nativeIn',
        defaultMessage: '{sku} is a {gender} talent, age {age} with native proficiency in {languages}.',
    },
    listenTo: {
        id: 'containers.AiPage.listenTo',
        defaultMessage: 'Listen to the original human demo below, and click book to get a free quote on a professional voice over.',
    },
    view: {
        id: 'containers.AiPage.view',
        defaultMessage: 'Book {sku}',
    },
    sku: {
        id: 'containers.AiPage.sku',
        defaultMessage: "{sku}",
    },
    skuDefault: {
        id: 'containers.AiPage.sku.default',
        defaultMessage: 'AI voice demo',
    },
    legalNotice: {
        id: 'containers.AiPage.legalNotice',
      defaultMessage: 'For non-commercial demonstrations purposes use only. Any use outside VoiceArchive website is currently prohibited, and violates our <tcs>terms and conditions</tcs>.',
    },
    statement: {
        id: 'containers.AiPage.statement',
      defaultMessage: 'Read <link>our statement</link> on our AI standpoint and commitments to our voice talent, in our new AI section.'
    },
    age: {
      id: 'containers.AiPage.age',
      defaultMessage: '{age} of age',
    },
    scriptFlagged: {
        id: 'containers.AiPage.flagged',
        defaultMessage: 'Your script has been flagged for moderation. Please try again.',
    },
    scriptProfanity: {
        id: 'containers.AiPage.profanity',
        defaultMessage: 'Your script contains profanity. Please try again.',
    },
    suggestionLoading: {
        id: 'containers.AiPage.suggestionLoading',
        defaultMessage: 'Loading...',
    },
    suggestionButton: {
        id: 'containers.AiPage.suggestionButton',
        defaultMessage: 'Suggest script',
    },
})
